import EventManager from "../../../store/sqftEventManager";
import workspace from "../../workspace";
import config from "../../../store/sqftConfig";
import {getMousePositionOnField} from "../../../../../helpers/sqftHelper";
import {pnpolyArray} from "../../../../../lib/pnpoly";

export default class Movable {

  state = {
    hoveringOnlyShape: false,
    mouseDown: false,
    mouseDownWithChildren: false,
    mouseDownPosition: null,
    hovering: false,
    hoveringWithChildren: false,
    handlerHold: null
  };
  _posX;
  _posY;
  _width;
  _height;
  isResizedByPoint = false;
  priority;
  parent;
  grandParent;
  moveCallback = null;
  mouseUpCallback = null;
  mouseDownCallback = null;

  constructor(posX,
              posY,
              width,
              height,
              priority = EventManager.priorities.IMAGE,
              parent = null,
              grandParent = null,
              moveCallback = null,
              mouseUpCallback = null,
              mouseDownCallback = null
  ) {
    this.priority = priority;
    this.parent = parent;
    this.grandParent = grandParent;
    this.moveCallback = moveCallback;
    this.mouseUpCallback = mouseUpCallback;
    this.mouseDownCallback = mouseDownCallback;

    this.initEvents();
    this._posX = posX;
    this._posY = posY;
    this._width = width;
    this._height = height;
  }

  get posX() {
    return this._posX;
  }

  set posX(value) {
    this._posX = value;
  }

  get posY() {
    return this._posY;
  }

  set posY(value) {
    this._posY = value;
  }

  get width() {
    return this._width;
  }

  set width(value) {
    this._width = value;
  }

  get height() {
    return this._height;
  }

  set height(value) {
    this._height = value;
  }

  initEvents() {
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this.onMouseMove.bind(this),
      this,
      this.priority
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this.onMouseDown.bind(this),
      this,
      this.priority
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      this.onMouseUp.bind(this),
      this,
      this.priority
    );
  }

  deregisterEvents() {
    EventManager.removeEvent(this);
  }

  reInitEvents = () => {
    this.initEvents();
  }

  onMouseMove(mousePos, e) {
    if (e.terminate && !this.state.mouseDown) {
      this.setHoveringOnlyShape(false);

      return this.setHovering(false);
    }

    if (this.state.mouseDown) {
      EventManager.setCursor('move', this, true);
      if (this.moveCallback) {
        this.moveCallback(mousePos, this);
      } else {
        this.movePosition(mousePos);
      }
    }

    if (this.isMouseOverArea(mousePos)) {
      this.setHovering(true);

      EventManager.setCursor('move', this);
      return this.state.mouseDown;
    }
    if (this.parent.points !== undefined) { // todo this should be children not points
      for (const point in this.parent.points) {
        if (this.parent.points.hasOwnProperty(point)) {
          if (this.parent.points[point].modelCorePoint.mixins.movable.state.hovering) {
            this.setHoveringWithChildren(true);

            return this.state.hoveringWithChildren
          }
        }
      }
    }

    this.setHovering(false);
    this.setHoveringWithChildren(false);
    EventManager.resetCursor(this);

    return false;
  }

  onMouseUp(mousePos) {
    EventManager.releaseStealLock(self);
    this.state.mouseDown = false;
    this.state.mouseDownPosition = null;
    if (this.mouseUpCallback) {
      this.mouseUpCallback(mousePos, this);
    }
  }

  onMouseDown(mousePos, e) {
    void e;
    if (this.isHovering()) {
      //if (EventManager.getCursor().indexOf("move") >= 0) {
        this.state.mouseDown = true;
        this.state.mouseDownPosition = mousePos;
      //}
      if (this.mouseDownCallback) {
        this.mouseDownCallback(mousePos, this);
      }
      return true;
    }
    return false;
  }
  isHovering () { return this.state.hovering === true; }
  setHoveringOnlyShape(value) { this.state.hoveringOnlyShape = value; return value; }
  setHovering(value) { this.state.hovering = value; return value; }
  setHoveringWithChildren(value) { this.state.hoveringWithChildren = value; return value; }

  movePosition(mousePos) {
    let scale = workspace.getScale();
    let xDiff = (this.state.mouseDownPosition.x - mousePos.x) / scale;
    let yDiff = (this.state.mouseDownPosition.y - mousePos.y) / scale;

    this.state.mouseDownPosition.x = mousePos.x;
    this.state.mouseDownPosition.y = mousePos.y;

    //todo this should be outside of the class
    if (this.parent.params.isResizedByPoint) {
      // 0 point
      // this.grandParent.posX -= xDiff;
      // this.grandParent.posY -= yDiff;

      //3 point
      // this.grandParent.posX -= xDiff;
      // this.grandParent.mixin.movable.width += xDiff;
      // this.posX -= xDiff;

      //4 point
      if (this.grandParent.width - xDiff >= this.grandParent.design.minimumWidth) {
        this.grandParent.width -= xDiff;
        this.grandParent.mixin.movable.width -= xDiff;
        this.posX -= xDiff;

        // change p7 x cord
        // todo grandParent setter
        this.grandParent.points.p7.modelCorePoint.mixins.movable.posX -= xDiff;

        // update textarea width
        // todo get from the parent class

        let textarea = document.querySelector('.i-text');
        if (textarea) {
          let width = textarea.offsetWidth;
          width -= xDiff * 4;
          textarea.style.width = width + 'px';
        }
      }
    } else if (this.parent.params.isScaledByPoint) {
      // 7 point (scaled)
      if (this.grandParent.height - (xDiff + yDiff) / 2 >= this.grandParent.design.minimumHeight
        && this.grandParent.width - (xDiff + yDiff) / 2 >= this.grandParent.design.minimumWidth
      ) {
        this.grandParent.width -= (xDiff + yDiff) / 2;
        this.grandParent.height -= (xDiff + yDiff) / 2;
        this.grandParent.mixin.movable.width -= (xDiff + yDiff) / 2;
        this.grandParent.mixin.movable.height -= (xDiff + yDiff) / 2;

        this.posX -= (xDiff + yDiff) / 2;
        this.posY -= (xDiff + yDiff) / 2;

        //change point 4 x cord
        //todo grandParent setter
        this.grandParent.points.p4.modelCorePoint.mixins.movable.posX -= (xDiff + yDiff) / 2;
      }
    } else {
      this.posX -= xDiff;
      this.posY -= yDiff;
    }
  }

  isMouseOverArea (mousePos) {
    let offset = this.grandParent && this.grandParent.getPosition && this.grandParent.isLastParent !== true
      ? this.grandParent.getPosition()
      : {x: 0, y: 0};

    let pointsArray;

    if (this.parent.design !== undefined && this.parent.design.layout === "resize") { // centered cords for points
      pointsArray = [
        [this.posX + offset.x - this.parent.design.radius / 2, this.posY + offset.y - this.parent.design.radius / 2],
        [this.posX + offset.x + this.parent.design.radius / 2, this.posY + offset.y - this.parent.design.radius / 2],
        [this.posX + offset.x + this.parent.design.radius / 2, this.posY + offset.y + this.parent.design.radius / 2],
        [this.posX + offset.x - this.parent.design.radius / 2, this.posY + offset.y + this.parent.design.radius / 2],
      ];
    } else if (this.parent.params && this.parent.params.isCenteredByY) { // centered cords for points
      pointsArray = [
        [this.posX + offset.x, this.posY + offset.y - this.parent.design.radius / 2],
        [this.posX + this.width + offset.x, this.posY + offset.y - this.parent.design.radius / 2],
        [this.posX + this.width + offset.x, this.posY + this.height + offset.y - this.parent.design.radius / 2],
        [this.posX + offset.x, this.posY + this.height + offset.y - this.parent.design.radius / 2],
      ];
    } else if (this.parent.params && this.parent.params.isCentered) { // centered cords for points
      pointsArray = [
        [this.posX + offset.x - this.width / 2, this.posY + offset.y - this.height / 2],
        [this.posX + offset.x + this.width / 2, this.posY + offset.y - this.height / 2],
        [this.posX + offset.x + this.width / 2, this.posY + offset.y + this.height / 2],
        [this.posX + offset.x - this.width / 2, this.posY + offset.y + this.height / 2],
      ];
    } else {
      pointsArray = [
        [this.posX + offset.x, this.posY + offset.y],
        [this.posX + this.width + offset.x, this.posY + offset.y],
        [this.posX + this.width + offset.x, this.posY + this.height + offset.y],
        [this.posX + offset.x, this.posY + this.height + offset.y],
      ];
    }

    let posOnField = getMousePositionOnField(mousePos.x, mousePos.y);

    return pnpolyArray(pointsArray, posOnField);
  }

  isMouseOverAreaByMousePOs (mousePos) {
    let scale = config.scale;
    let pointsArray = [
      [this.posX, this.posY],
      [this.posX + this.width * scale, this.posY],
      [this.posX + this.width * scale, this.posY + this.height * scale],
      [this.posX, this.posY + this.height * scale],
    ];

    return pnpolyArray(pointsArray, mousePos);
  }
}
